import Vue from "vue";
import VueRouter from "vue-router";
// import { getUserToken } from "@/utils/Cookie";
Vue.use(VueRouter);
const __import__ = (file) => () => import(`@/views/${file}.vue`);
const routes = [
	{
		path: "/",
		name: "Home",
		component: __import__("index/Home"),
		meta: {
			requireAuth: false,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/promotion",
		name: "promotion",
		component: __import__("promotion/promotion"),
		meta: {
			title: "推广中心",
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/Paid",
		name: "Paid",
		component: __import__("paid/paid"),
		meta: {
			title: "付款成功",
			requireAuth: false,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/Personal",
		name: "Personal",
		component: __import__("personal/personal"),
		meta: {
			title: "个人设置",
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/ticket",
		name: "ticket",
		component: __import__("ticket/ticket"),
		meta: {
			title: "店铺小票机",
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/Returns",
		name: "Returns",
		component: __import__("Returns/Returns"),
		meta: {
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/Deposit",
		name: "Deposit",
		component: __import__("deposit/deposit"),
		meta: {
			title: "立即提现",
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/LinkAPI",
		name: "LinkAPI",
		component: __import__("deposit/LinkAPI"),
		meta: {
			title: "立即提现",
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},

	{
		path: "/indent",
		name: "indent",
		component: __import__("indent/indent"),
		meta: {
			title: "订单明细",
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/subordinate",
		name: "subordinate",
		component: __import__("subordinate/subordinate"),
		meta: {
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/merchant",
		name: "merchant",
		component: __import__("merchant/merchant"),
		meta: {
			title: "商家入驻",
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/merchantsSettlement",
		name: "merchantsSettlement",
		component: __import__("merchant/merchantsSettlement"),
		meta: {
			title: "商家入驻",
			requireAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: "/generalize",
		name: "generalize",
		component: __import__("generalize/generalize"),
		meta: {
			title: "推广赚钱",
			requireAuth: true,
			keepAlive: false, //需要缓存
		},
	},
	{
		path: "/popularize",
		name: "popularize",
		component: __import__("generalize/popularize"),
		meta: {
			title: "推广赚钱",
			requireAuth: false,
			keepAlive: false, //不需要缓存
		},
	},
	{
		path: "/audit",
		name: "audit",
		component: __import__("audit/audit"),
		meta: {
			title: "审核中",
			requireAuth: true,
			keepAlive: false, //不需要缓存
		},
	},
];

const router = new VueRouter({
	// mode: "history",
	base: process.env.BASE_URL,
	routes,
});
// function IsWeixinOrAlipay() {
//   var ua = window.navigator.userAgent.toLowerCase();
//   //判断是不是微信
//   if (ua.match(/MicroMessenger/i) == "micromessenger") {
//     return "1";
//   }
//   //判断是不是支付宝
//   if (ua.match(/AlipayClient/i) == "alipayclient") {
//     return "2";
//   }
//   //哪个都不是
//   return "3";
// }

// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     //进行页面title改变
//     window.document.title = to.meta.title;
//   }
//   let UserKey = getUserToken(); //获取token

//   let IsWeixinOrAlipa = IsWeixinOrAlipay(); //获取是否是支付宝活微信环境值

//   if (to.meta.requireAuth == true) {
//     //进行判断是否需要token
//     if (IsWeixinOrAlipa != "3") {
//       //判断是否是微信或支付宝环境
//       if (!UserKey) {
//         //判断是否有token
//         next({ name: "popularize" }); //没有就跳转到指定页面
//       } else {
//         next(); //跳转正常页面
//       }
//     } else {
//       next({ name: "Home" }); //跳转指定页面
//     }
//   } else {
//     if (IsWeixinOrAlipa == "3") {
//       //判断如果是其他页面进入
//       if (to.name == "Home") {
//         //如果页面是指定页面就不用动了
//         next();
//       } else {
//         //如果不是就跳转指定页面
//         next({ name: "Home" });
//       }
//     } else {
//       next(); //否则正常页面走
//     }
//   }
//   if (to.fullPath == "/Home") {
//     if (UserKey) {
//       next({
//         path: from.fullPath,
//       });
//     } else {
//       next();
//     }
//   }
// });

export default router;
